import type { GearFindingDto, SightingDto } from '../sightings';
import '../voyage-reports.css';

const ll = (d?: string | null, m?: string | null, s?: string | null) => (d || m ? `${d ?? ''}°${m ?? ''}′${s ?? ''}` : '');
const yn = (b: boolean) => (b ? '有' : '無');

/** 視認状況報告（参照用の表） */
export function SightingReadTable({ rows }: { rows: SightingDto[] }) {
  if (!rows.length) return <p className="bs-cell-sub">視認状況報告はありません。</p>;
  return (
    <table className="bs-survey-table">
      <thead>
        <tr>
          <th>視認日時</th>
          <th>監視作業水域</th>
          <th>農林漁区番号</th>
          <th>緯度・経度</th>
          <th>操業等</th>
          <th>進行方向</th>
          <th>国籍</th>
          <th>船名・登録番号・承認番号</th>
          <th>漁業種類</th>
          <th className="is-num">隻数</th>
          <th>通報/写真</th>
          <th>参照</th>
          <th>特記事項</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id}>
            <td className="is-num">
              {r.sightedOn.slice(5).replace('-', '/')} {r.sightedTime ?? ''}
            </td>
            <td>{r.monitoringArea}</td>
            <td className="is-num">
              {r.zoneNo ?? '—'}
              {r.zoneNoCalculated != null && r.zoneNoCalculated !== r.zoneNo && <span className="bs-cell-sub">算出 {r.zoneNoCalculated}</span>}
            </td>
            <td className="is-num">
              N{ll(r.latDeg, r.latMin, r.latSec)}
              <br />E{ll(r.lonDeg, r.lonMin, r.lonSec)}
            </td>
            <td>{r.activity}</td>
            <td>{r.heading}</td>
            <td>{r.nationality}</td>
            <td>{[r.foreignVesselName, r.foreignRegistrationNo, r.approvalNo].filter(Boolean).join(' ／ ')}</td>
            <td>{r.fishingType}</td>
            <td className="is-num">{r.vesselCount}</td>
            <td>
              {yn(r.isReported)}/{yn(r.hasPhoto)}
            </td>
            <td>{[r.refFixedTime && '定時', r.refVoyage && '速報'].filter(Boolean).join('・')}</td>
            <td>{r.specialNotes}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/** 漁場調査等（参照用の表） */
export function GearReadTable({ rows }: { rows: GearFindingDto[] }) {
  if (!rows.length) return <p className="bs-cell-sub">漁具の発見情報はありません。</p>;
  return (
    <table className="bs-survey-table">
      <thead>
        <tr>
          <th>発見日時</th>
          <th>監視作業水域</th>
          <th>農林漁区番号</th>
          <th>緯度・経度</th>
          <th>漁具種類</th>
          <th>個数</th>
          <th>国籍</th>
          <th>漁具の特徴等</th>
          <th>写真</th>
          <th>特記事項</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id}>
            <td className="is-num">
              {r.foundOn.slice(5).replace('-', '/')} {r.foundTime ?? ''}
            </td>
            <td>{r.monitoringArea}</td>
            <td className="is-num">{r.zoneNo ?? r.zoneNoCalculated ?? '—'}</td>
            <td className="is-num">
              N{ll(r.latDeg, r.latMin, r.latSec)}
              <br />E{ll(r.lonDeg, r.lonMin, r.lonSec)}
            </td>
            <td>{r.gearType}</td>
            <td>{r.gearCount}</td>
            <td>{r.nationality}</td>
            <td>{r.gearFeatures}</td>
            <td>{yn(r.hasPhoto)}</td>
            <td>{r.specialNotes}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
